var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dialog',{attrs:{"title":"","visible":_vm.open,"width":"50%"},on:{"update:visible":function($event){_vm.open=$event}}},[_c('div',{staticClass:"chart-container"},[_c('div',{attrs:{"id":"chart_box"}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }